"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETING_COLORS = void 0;
exports.MARKETING_COLORS = {
    "atlantic": { "code": "#16618c", "mode": { "dark": true, "standard": false } },
    "black900": { "code": "#000000", "mode": { "dark": true, "standard": false } },
    "caspian": { "code": "#204949", "mode": { "dark": true, "standard": false } },
    "celtic": { "code": "#046240", "mode": { "dark": true, "standard": false } },
    "darkGrey": { "code": "#5c5c5c", "mode": { "dark": true, "standard": false } },
    "emerald": { "code": "#0a806b", "mode": { "dark": true, "standard": false } },
    "graphite": { "code": "#313131", "mode": { "dark": true, "standard": false } },
    "holiday": { "code": "#9a0202", "mode": { "dark": true, "standard": false } },
    "holidayBeige1": { "code": "#ede3cf", "mode": { "dark": false, "standard": true } },
    "holidayGreen1": { "code": "#50af60", "mode": { "dark": false, "standard": true } },
    "holidayGreen2": { "code": "#06462E", "mode": { "dark": true, "standard": false } },
    "holidayRed1": { "code": "#8b0d13", "mode": { "dark": true, "standard": false } },
    "holidayRed2": { "code": "#8b0d13", "mode": { "dark": true, "standard": false } },
    "kingfisher": { "code": "#017eb4", "mode": { "dark": true, "standard": false } },
    "mediumGreen": { "code": "#318643", "mode": { "dark": true, "standard": false } },
    "mediumGrey": { "code": "#dfdfdf", "mode": { "dark": false, "standard": true } },
    "opal": { "code": "#c0e6df", "mode": { "dark": false, "standard": true } },
    "platinum": { "code": "#efefef", "mode": { "dark": false, "standard": true } },
    "rio": { "code": "#99d3f3", "mode": { "dark": false, "standard": true } },
    "rum": { "code": "#c94b2f", "mode": { "dark": true, "standard": false } },
    "talavera": { "code": "#2b3b55", "mode": { "dark": true, "standard": false } },
    "warmWhite": { "code": "#f6f6ec", "mode": { "dark": false, "standard": true } },
    "white": { "code": "#ffffff", "mode": { "dark": false, "standard": true } }
};
